import { YearGroupOptions } from 'cb-model';

export const ProfileYearGroupOptions = YearGroupOptions.filter((option) => option.id !== 'all_years');

export const normalizeEmploymentGrade = (grade?: string | null): string | undefined => {
  if (!grade || grade === '0') {
    return undefined;
  }
  return grade;
};
